define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/NodeImage",
	"csi/html",
	"csi/image/_base",
	"csi/locale",
	"csi/reflection",
	"csi/utility/pathUtility",
	"csi/xml"
], function(declare, _, NodeImage, html, csiImage, locale, reflection, {pathCreate}, xml) {

	return declare(NodeImage, {
		/** @property {boolean} tiny - indicates images should be 32x32 in size */
		tiny: false,

		/**
		 * @override
		 * Even though we're using NodeImage which allows us to specify a path to the image, we still need the image
		 * node for a number of reasons:
		 * 1. We need to predict the image height and width to properly calculate the table row height
		 * 2. We need the image node to understand if it is a turntable image or not
		 */
		addRendererDependencyPaths(h, paths) {
			paths.push(pathCreate(h.m_path, h.m_id, csiImage.getDefaultImagePath()));
		},

		canBeLarge: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return 2 indicating it is large - this overrides the logic in RefImage where the return
			// value is dependent on the image size (which is not a factor here - it always shows thumbnails)
			return 2;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render default thumbnail image for each node referenced by container attribute
			var nodes = ctx.cache.getNodes(ctx.getNodeAttributeValue(h.m_id));
			var imageSizeOld = ctx.prefImageSize;

			// NOTE: in some cases these lists contain empty references, so ignore those here
			nodes = _.compact(nodes);

			// sort nodes if the attribute is not a vector.
			if ((nodes.length > 1) && (xml.nodeAttributeGetType(ctx.getNode(), h.m_id) != xml.ATTR_REFVECTOR)) {
				nodes = xml.sortNodes(nodes);
			}

			ctx.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;
			ctx.forEach(nodes, function(ctx, i) {
				// Loop through nodes and create image thumb nails
				if (!NodeImage.prototype.toHtmlStatic.call(this, ctx, h, refNode, actionData)) {
					//create node for image missing
					html.create("div", {
						"class": "csiNodeImageMissing",
						innerText: locale.getNodeConfiguredName(ctx.getNode(), ctx.cache)
					}, refNode);
				}
			}, this);

			ctx.prefImageSize = imageSizeOld;
			return !!nodes.length;
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: no editing possible
			return null;
		},

		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: don't want "attrImage" on root node - only on each child node
			const css = ["csiNodeImages"];
			const rc = h.rca?.getDestinationClass(h.rc);

			if (this.tiny) {
				css.push("csiNodeImagesTiny");
			}

			if (rc) {
				css.push(`csiNodeImagesFor-${rc.type}-${h.m_id}`);
			}

			return css.join(" ");
		},

		_onImageLoad: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/domNode) {
			//summary: put span around images for spacing
			this.inherited(arguments);
			html.create("span", {"class": "attrImage"}, domNode, "around");
		}
	});
});